import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "StimFetchError", "Error fetching stim for $step_type$ $step_id$", config.defaultMessageId)